import { defineComponent, h, withDirectives, resolveDirective } from 'vue';
import { QInput } from 'quasar';
import BaseComponent from './baseFormMixin.jsx';
import variableBindingMixin from './variableBindingMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import { appSettings } from '@/Shared/appSettings.js';

import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-text',
    mixins: [BaseComponent, variableBindingMixin],
    components: {
        QInput,
        TranslationContainer
    },
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        if (this.autofocus)
            setTimeout(() => {
                const item = this.$refs[this.autofocus_id];
                if (item) {
                    this.$refs[this.autofocus_id].focus();

                    let inputEl = this.$refs[this.autofocus_id].$el.querySelector('input');
                    inputEl.select();

                    //this.input = 'test value'
                    setTimeout(() => {
                        inputEl.select();
                    }, 200);
                }
            }, 250);

        this.loadComplete();
    },
    methods: {
    },
    render() {
        const variableField = this.tryRenderVariableBindingField({ class: 'c-formText caption sform-input-white c-variable-binding-select' });
        if (variableField)
            return variableField;

        let slots = {};
        if (this.element.fieldAddonLeft)
            slots.prepend = () => this.element.fieldAddonLeft;
        if (this.hintText && appSettings.DebugTranslationPrefixSetting)
            slots.hint = () => <TranslationContainer context={this} value={this.hintText}></TranslationContainer>;
        slots = this.mergeVariableAssistSlots(slots);

        let input =
            <QInput
                type="text"
                class="c-formText caption sform-input-white"
                ref={this.autofocus ? this.autofocus_id : undefined}
                outlined
                dense
                label={this.inputLabel}
                style={{ width: "100%" }}
                modelValue={this.itemvalue}
                rules={this.rules} {...this.compilerErrorFieldProps}
                hint={this.inputHint}
                hide-hint
                bottom-slots={this.showFieldBottomSlots}
                onUpdate:modelValue={(value) => this.sync(value) }
                onFocus={() => { this._vbFocused = true; this.onFocus(); }}
                onBlur={() => { this._vbFocused = false; this.onBlur(); }}
            >
                {slots}
            </QInput>;
       

        if (this.appearance)
            utils.applyVue2ToVue3Props(input, this.appearance);

        // if (this.directives && this.directives.some(a => a.name == 'on-enter-default'))
        //    input.props.autofocus = true;

        if (this.directives) {
            var applyDirectives = this.directives.map(d => {
                const dirDef = d.directive || resolveDirective(d.name);

                return [dirDef, d.value, d.arg, d.modifiers];
            });
            input = withDirectives(input, applyDirectives);
        }

        return this.wrapLiteralWithVariableAssist(input);
    }
});
